import React, { useState, useEffect, useRef, useContext } from 'react';
import { parseISO, format, getDate, getMonth, getWeek, eachDayOfInterval, eachWeekOfInterval } from 'date-fns'
import { setMonth, setYear, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addMonths, subMonths, addDays, subDays, isSameDay } from 'date-fns'
import { sv } from 'date-fns/locale'

import './css/fm_input.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Fr_Input extends React.Component {
  constructor(props, context) {
    super(props);

    this.node = React.createRef();
    //this.setNodeRef = this.setNodeRef.bind(this);

    this.state = {};
    this.state.itemx = [];
    this.state.lso = {};
    //this.state.lro = props.lro;
    this.state.cols = {};
    this.state.sel_show = false;
    this.state.sel_step = 0;

    //context.posrend = this;
    this.state.today = new Date();
    this.state.ctrltext = "";
    if(props.text) this.state.ctrltext = props.text.toString();
    this.state.txtval = "";
    this.state.txtsel = 0;
    if(props.text) this.state.txtval = props.text.toString().trim();
    this.state.row = 0;
    if(props.row) this.state.row = 1;
    this.state.col = 0;
    if(props.col) this.state.col = 1;
    this.state.placeholder = "";
    if(props.placeholder) this.state.placeholder = props.placeholder;
      this.state.type = "text";
      if(props.type) this.state.type = props.type;
      this.state.readonly = 0;
      if(props.readonly) this.state.readonly = 1;
      this.state.accept = "";
      if(props.accept) this.state.accept = props.accept;

    this.txtsel = 0;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
    //document.removeEventListener("mousedown", this.handleClick);
  }
  componentDidMount() {
    //document.addEventListener("mousedown", this.handleClick);
    this.setState({ txtsel: false })
  }

  cls() {
    var cls = "";
    cls = "ff_ctrl flex";
    //if(this.props.className) cls = cls + " " + this.props.className;
    if(this.props.noflex) cls = "ff_ctrl";
    return cls;
  }

  clsGroup() {
    var cls = "";
    cls = "form-group";
    if(!this.props.col) cls = cls + " flex-row";
    if(this.props.col) cls = cls + " flex-column";
    cls = cls + " flex";
    return cls;
  }
  clsFrm() {
    var cls = "";
    cls = "";
    if(this.props.row) cls = "flex-row";
    return cls;
  }

  clsInput() {
    var cls = "";
    cls = "form-control";
    if(this.props.className) cls = cls + " " + this.props.className;
    return cls;
  }
  clsLabel() {
    var cls = "";
    cls = "header txt_12";
      if(this.props.noheader) cls = "no_label";
      if(this.props.headright) cls = cls + " text-right";
    return cls;
  }

  showsel(e) {
      e.preventDefault();

      var brc = this.state.sel_show;
      brc = !brc;
      //var val = this.props.text;
      //this.setState({sel_show: brc, sel_step: 0, txtval: val});
      //this.setState({txtsel: true});
   }
   onFocus(e) {
    e.preventDefault();

    this.setState({txtsel: 1});
    }
    onKeyDown(e) {
      //e.preventDefault();

      if(this.props.onKeyDown) this.props.onKeyDown(e);
    }
    onBlur(e) {
      e.preventDefault();

      this.setState({txtsel: 0});
      if(this.state.txtval.length > 0) {
          //this.props.getValue(this.state.txtval);
      }
    }

    changeHandler (e) {
      e.preventDefault();
      if(this.state.readonly == 1) return;

      var value = e.target.value;
      if(this.state.type == "file") {
        //alert(JSON.stringify(e.target.files));
        if(e.target.files.length > 0) value = e.target.files[0];
      }
      
      //alert("CHANGE: " + JSON.stringify(value));
      //this.setState({ txtval: value });
      this.props.getValue(value);
    }
    inputClick (e) {
      //e.preventDefault();
      if(this.props.onClick) {
          this.props.onClick(e);
      }
    }

  inputStyle() {
      var css = {};
      if(this.state.cal_show) {
        css.background = "#080";
        css.color = "#fff";
      }
      return css;
  }
  label_style() {
    var css = {};

    if(this.state.row) {
        css.width = "75px";
        css.fontSize = "14px";
        css.background = "#fff";
        css.color = "#800";
    }

    return css;
  }
    updateState = (value) => {
      //alert("CTRL: " + value);
      this.setState({ txtval: value });
    }

  render() {
    //if(!this.props.show) return "";
    //alert(this.props.ctx.state.lro);

    var title = this.props.title;
    if(!title) title = "URVAL";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div ref={this.node} className={ this.cls() }>
        <div className={ this.clsGroup() }>
            <span className={ this.clsLabel() }>{ this.props.label }</span>

            { this.props.accept ?
            <input type={ this.state.type } accept={ this.state.accept } className={ this.clsInput() }
               value={this.props.text} onClick={(e) => this.inputClick(e)}
               placeholder={this.state.placeholder} onChange={(e) => this.changeHandler(e)}
               onFocus={(e) => this.onFocus(e)} onBlur={(e) => this.onBlur(e)} onKeyDown={(e) => this.onKeyDown(e)}
            />
            : 
            <input type={ this.state.type } className={ this.clsInput() }
               value={this.props.text} onClick={(e) => this.inputClick(e)}
               placeholder={this.state.placeholder} onChange={(e) => this.changeHandler(e)}
               onFocus={(e) => this.onFocus(e)} onBlur={(e) => this.onBlur(e)} onKeyDown={(e) => this.onKeyDown(e)}
            />
            }

            { this.props.sz ?
            <div className="input-group-append">
                <div className="text-center input-group-text h-100" onClick={() => this.props.sz() }>
                    <FontAwesomeIcon icon="search" size="1x"/>
                </div>
            </div>
            : null }
        </div>
        </div>
	;
	return html;
  };
}

export default Fr_Input;

//{...this.props}